import { AngularApp } from './angular-app';

window.customElements.define(AngularApp.name, AngularApp);



// WEBPACK FOOTER //
// ./src/components/angular-app/main.js